function parseHexColor(value) {
  if (typeof value !== "string") return null;
  const hex = value.trim().replace(/^#/, "");
  if (!/^(?:[\da-f]{3}|[\da-f]{6})$/i.test(hex)) return null;
  const full =
    hex.length === 3
      ? hex
          .split("")
          .map((digit) => digit + digit)
          .join("")
      : hex;
  return [0, 2, 4].map((index) => parseInt(full.slice(index, index + 2), 16));
}

function luminance([red, green, blue]) {
  const [r, g, b] = [red, green, blue].map((channel) => {
    const value = channel / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

function readableText(rgb, opacity = 1) {
  const overWhite = rgb.map((channel) => Math.round(channel * opacity + 255 * (1 - opacity)));
  const value = luminance(overWhite);
  return (value + 0.05) / 0.05 >= 1.05 / (value + 0.05) ? "#000000" : "#ffffff";
}

export function getStoreColorVariables(primary) {
  const rgb = parseHexColor(primary);
  if (!rgb) return null;

  const fill = `rgb(${rgb.join(", ")})`;
  const translucent = (opacity) => `rgba(${rgb.join(", ")}, ${opacity})`;
  const text = readableText(rgb);

  return {
    "--theme-action-fill": fill,
    "--theme-action-text": text,
    "--theme-action-subtext": text,
    "--theme-sold-fill": translucent(0.7),
    "--theme-sold-text": readableText(rgb, 0.7),
    "--theme-disabled-fill": fill,
    "--theme-disabled-text": text,
    "--theme-disabled-subtext": text,
    "--theme-focus": fill,
    "--theme-shipping-outline": fill,
    "--theme-payment-outline": fill,
    "--theme-discount-outline": fill,
    "--theme-selection-fill": translucent(0.05),
    "--theme-accent": fill,
  };
}
